(() => {
  const root = document.querySelector('[data-tcg-hub-gap-teaser]');
  if (!root) return;

  const hub = window.Kl24PokemonHub;
  if (!hub) return;

  const list = root.querySelector('[data-hub-gap-list]');
  const highlightsAsset = root.dataset.highlightsAsset || '';
  const maxSets = Math.max(1, Number.parseInt(root.dataset.maxSets || '3', 10) || 3);
  const minStock = Math.max(1, Number.parseInt(root.dataset.minStock || '3', 10) || 3);
  const gapBaseUrl = root.dataset.gapBaseUrl || '/pages/gap-filler';

  const buildGapUrl = (handle) => {
    const base = gapBaseUrl.split('?')[0];
    return `${base}?set=${encodeURIComponent(handle)}`;
  };

  const formatStockLabel = (count) => {
    if (count >= minStock) {
      return `${count} Karten auf Lager`;
    }
    return 'Set ergänzen';
  };

  const renderSet = (set) => {
    const li = document.createElement('li');
    li.className = 'tcg-hub-gap-teaser__item';

    const link = document.createElement('a');
    link.className = 'tcg-hub-gap-teaser__link';
    link.href = buildGapUrl(set.handle);
    link.setAttribute('data-hub-gap-set', set.handle || '');

    const name = document.createElement('span');
    name.className = 'tcg-hub-gap-teaser__set-name';
    name.textContent = set.name || set.handle || 'Set';

    const stat = document.createElement('span');
    stat.className = 'tcg-hub-gap-teaser__set-stat';
    const count = Number(set.in_stock_count) || 0;
    stat.textContent = formatStockLabel(count);

    link.append(name, stat);
    li.append(link);
    return li;
  };

  (async () => {
    const highlights = await hub.fetchHighlights(highlightsAsset);
    const sets = (highlights?.top_gap_sets || [])
      .filter((set) => (Number(set.in_stock_count) || 0) >= minStock)
      .slice(0, maxSets);
    if (!list || sets.length === 0) {
      root.hidden = true;
      return;
    }
    root.hidden = false;
    list.replaceChildren();
    sets.forEach((set) => list.append(renderSet(set)));
  })();
})();
